import { Card } from "@/components/ui/card";

export default function KpiCard({ label, value, accent = "slate", icon: Icon, testId, onClick, active }) {
  const palettes = {
    purple: "text-cyan-800 bg-cyan-50 border-cyan-200",
    amber: "text-yellow-900 bg-yellow-50 border-yellow-200",
    orange: "text-orange-900 bg-orange-50 border-orange-200",
    green: "text-emerald-900 bg-emerald-50 border-emerald-200",
    red: "text-rose-900 bg-rose-50 border-rose-200",
    slate: "text-slate-900 bg-slate-50 border-slate-200",
  };
  const valueColors = {
    purple: "text-cyan-800",
    amber: "text-yellow-700",
    orange: "text-orange-700",
    green: "text-emerald-700",
    red: "text-rose-700",
    slate: "text-slate-900",
  };
  const activeRings = {
    purple: "ring-2 ring-purple-400 ring-offset-1",
    amber: "ring-2 ring-yellow-400 ring-offset-1",
    orange: "ring-2 ring-orange-400 ring-offset-1",
    green: "ring-2 ring-emerald-400 ring-offset-1",
    red: "ring-2 ring-rose-400 ring-offset-1",
    slate: "ring-2 ring-slate-400 ring-offset-1",
  };
  const interactive = typeof onClick === "function";
  const cardClasses = [
    "p-3 sm:p-4 flex items-start justify-between bg-white border border-slate-200 transition-all",
    interactive ? "cursor-pointer hover:shadow-md hover:-translate-y-0.5 active:translate-y-0" : "",
    active ? activeRings[accent] : "",
  ].join(" ");

  const content = (
    <>
      <div className="min-w-0">
        <div className="text-[10px] sm:text-xs font-semibold uppercase tracking-[0.18em] text-slate-500 truncate">{label}</div>
        <div className={`mt-1 sm:mt-2 text-2xl sm:text-3xl font-extrabold num ${valueColors[accent]}`}>
          {value ?? "—"}
        </div>
      </div>
      {Icon ? (
        <div className={`w-8 h-8 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center border flex-shrink-0 ${palettes[accent]}`}>
          <Icon size={18} />
        </div>
      ) : null}
    </>
  );

  if (interactive) {
    return (
      <Card
        data-testid={testId}
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick();
          }
        }}
        className={cardClasses}
        aria-pressed={!!active}
      >
        {content}
      </Card>
    );
  }
  return (
    <Card data-testid={testId} className={cardClasses}>
      {content}
    </Card>
  );
}
